import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold">RILG</h3>
            <p className="text-gray-400">
              Rise Independent Living Group - Empowering veterans to achieve stable, independent living.
            </p>
            <div className="flex space-x-4">
              <a href="tel:1.866.679.1134" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
              </a>
              <a href="mailto:info@rilg.org" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a href="https://www.facebook.com/share/19vHwq7Cv6/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-facebook-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white cursor-pointer">About Us</Link></li>
              <li><Link to="/housing" className="text-gray-400 hover:text-white cursor-pointer">Housing</Link></li>
              <li><Link to="/programs" className="text-gray-400 hover:text-white cursor-pointer">Programs</Link></li>
              <li><Link to="/apply" className="text-gray-400 hover:text-white cursor-pointer">Apply Now</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/residents" className="text-gray-400 hover:text-white cursor-pointer">Residents</Link></li>
              <li><Link to="/partners" className="text-gray-400 hover:text-white cursor-pointer">Partners</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Information</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line text-blue-400"></i>
                <span className="text-gray-400">4212 San Felipe St suite 548 Houston TX 77027</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-blue-400"></i>
                <span className="text-gray-400">1.866.679.1134</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-blue-400"></i>
                <span className="text-gray-400">info@rilg.org</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 RILG - Rise Independent Living Group. All Rights Reserved.
          </p>
          <div className="flex flex-wrap justify-center space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm cursor-pointer">Privacy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm cursor-pointer">Terms</Link>
            <Link to="/nondiscrimination" className="text-gray-400 hover:text-white text-sm cursor-pointer">Nondiscrimination</Link>
            <Link to="/accessibility" className="text-gray-400 hover:text-white text-sm cursor-pointer">Accessibility</Link>
            <Link to="/safety-rules" className="text-gray-400 hover:text-white text-sm cursor-pointer">Safety Rules</Link>
            <Link to="/visitor-policy" className="text-gray-400 hover:text-white text-sm cursor-pointer">Visitor Policy</Link>
            <Link to="/exit-policy" className="text-gray-400 hover:text-white text-sm cursor-pointer">Exit Policy</Link>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}